import script from "./FileRequestPop.vue?vue&type=script&setup=true&lang=ts"
export * from "./FileRequestPop.vue?vue&type=script&setup=true&lang=ts"

import "./FileRequestPop.vue?vue&type=style&index=0&id=1145bb54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1145bb54"]])

export default __exports__